import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Col, Row } from "react-bootstrap";
import StickyPageLayout from "../../../Layout/PageLayout/StickyPageLayout";
import MainTableList from "./MainTableList";
import ListLayout from "../../../Layout/PageLayout/ListLayout";
import { handleGetMainProduct_badlaForm, handleGetSubProduct_badlaForm, handleSubmit_bulkPriceForm } from "../sublimationPriceModel";
import { useDebounce } from "../../../../Utils/debounceAPI";
import BulkPriceTableList from "./BulkPriceTableList";
import { useGlobalAlert } from "../../../Common/Context/GlobalAlertContext";

  
const BulkPriceForm = () => {
  const navigate = useNavigate();
  const { showAlert } = useGlobalAlert();
  // const { showAlert } = useGlobalAlert();

  const location = useLocation();
  const [submitLoading, setSubmitLoading] = useState(false);

  // IMPORTANT => ALWAYS ARRAY
  const [search, setSearch] = useState("");
  const [dataList, setDataList] = useState([]);
  const [filteredList, setFilteredList] = useState([]);

  const [subProductList, setSubProductList] = useState([]);
  const [subFilterProductList, setFilterSubProductList] = useState([]);

  const [newSubData, setNewSubData] = useState({});
  const [selectedProduct, setSelectedProduct] = useState("");

  const [loading, setLoading] = useState(false);
  const [subLoading, setSubLoading] = useState(false);
  const [isSub, setIsSub] = useState(false);
 

  const fetchList_MainProducts = async () => {  
    try {
      await handleGetMainProduct_badlaForm({        
        filter: {},   
        setDataList,
        setFilteredList,
        setLoading,
      });
    } catch (err) {
      console.error("main products fetchList error:", err);
    }
  };

  const debouncedFetchMainProducts = useDebounce(fetchList_MainProducts, 400);

  useEffect(() => {
    debouncedFetchMainProducts(); // ✅ debounce here only
  }, []);

  const handleSearch = (text) => {
    setSearch(text);
    
    if (!text?.trim() || text.trim() == "".trim()) {      
      if(isSub===false){
        setFilteredList(dataList)}
      else{
        setFilterSubProductList(subProductList)
      }
      return;
    }
  
    const search = text.toLowerCase().trim();
    // SPLIT SEARCH WORDS
    const searchWords = search.split(/\s+/);
    let localResults=[];
    if(isSub===false){
      localResults = dataList?.filter((item) => {
        const combinedSearch = `
          ${item?.mpname || ""}
        `
          .toLowerCase()
          .trim();
  
        // EVERY WORD MUST MATCH
        return searchWords.every((word) =>
          combinedSearch.includes(word)
        );
      });
      setFilteredList(localResults); 
    }else{
      localResults = subProductList?.filter((item) => {
        const combinedSearch = `
          ${item?.subproduct_name || ""}
        `
          .toLowerCase()
          .trim();
  
        // EVERY WORD MUST MATCH
        return searchWords.every((word) =>
          combinedSearch.includes(word)
        );
      });
      setFilterSubProductList(localResults); 
    }
                  
  };

  const handle_SubProducts = async (mpid,productName) => { 
    handleSearch("");
    setIsSub(true)
    setSelectedProduct(productName)
    try {
      await handleGetSubProduct_badlaForm({        
        filter: {mpid:mpid,action:'bulkPrice'},   
        setSubProductList,
        setSubLoading,             
        setFilterSubProductList,
         
      });
    } catch (err) {
      console.error("main products fetchList error:", err);
    }
  };

  const handleSubmit =()=>{
    const allSizes = newSubData?.flatMap(
      (item) => item.sizes || []
    );
    let data={
      action:'patch_bulkPrice',
      dataList:allSizes
    }
    handleSubmit_bulkPriceForm({        
      data,   
      showAlert,
      setSubmitLoading,             
      setIsSub,
    });
    
  }

  return (
    <ListLayout
        title="Bulk Price Manage"
        searchValue={search}
        onSearch={handleSearch}
        onClearSearch={() => handleSearch("")} 
        onNewText="Submit"   
        onNewLoading={submitLoading}     
        onNew={(e) => {
          handleSubmit();
        }}
         
      >
      <Row className="g-3 align-items-stretch">
        {/* RECEIVABLE */}
        {/* {JSON.stringify(newSubData)} */}
        <Col lg={12} md={12}>
        {isSub===false?(
          <MainTableList
            title="Sub Products"             
            data={filteredList}
            loading={loading}                                   
            subLoading={subLoading}
            handle_SubProducts={handle_SubProducts}
          />
        ):(
          <BulkPriceTableList            
            data={subFilterProductList}
            subLoading={subLoading} 
            onBack={() => setIsSub(false)} 
            selectedProduct={selectedProduct}
            setNewSubData={setNewSubData}                 
          />
        )

        }
         
        </Col>         
      </Row>
    </ListLayout>
  );
};

export default BulkPriceForm;